import { render, staticRenderFns } from "./GroupFilesList.vue?vue&type=template&id=48382a5d&"
import script from "./GroupFilesList.vue?vue&type=script&lang=js&"
export * from "./GroupFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports